export default __webpack_public_path__ + "static/media/Q13_4_resized.883ef393.jpg";